export const links = {
  Home: {
    title: "Home",
    text: "Home",
    href: "/",
    icon: "",
    bgColor: "bg-light-1",
    ringColor: "ring-light-1",
  },
  Resume: {
    title: "Resume",
    text: "Resume",
    href: "/#resume",
    icon: "",
    bgColor: "bg-light-1",
    ringColor: "ring-light-1",
  },
  Projects: {
    title: "Projects",
    text: "Projects",
    href: "/#projects",
    icon: "",
    bgColor: "bg-light-1",
    ringColor: "ring-light-1",
  },
  Webpage: {
    title: "Webpage",
    text: "amiri.cc",
    href: "https://amiri.cc",
    icon: "fas fa-globe-americas",
    bgColor: "bg-dark-0",
    ringColor: "ring-dark-0",
  },
  Email: {
    title: "Email",
    text: "aasmpro@gmail.com",
    href: "mailto:aasmpro@gmail.com",
    icon: "fas fa-at",
    bgColor: "bg-red-0",
    ringColor: "ring-red-0",
  },
  Chat: {
    title: "Email",
    text: "Chat",
    href: "mailto:aasmpro@gmail.com",
    icon: "fas fa-at",
    bgColor: "bg-light-1",
    ringColor: "ring-light-1",
  },
  Phone: {
    title: "Phone",
    text: "+4915123176050",
    href: "tel:+4915123176050",
    icon: "fas fa-phone",
    bgColor: "bg-yellow-0",
    ringColor: "ring-yellow-0",
  },
  Talk: {
    title: "Phone",
    text: "Talk",
    href: "tel:+4915123176050",
    icon: "fas fa-phone",
    bgColor: "bg-light-1",
    ringColor: "ring-light-1",
  },
  CurrentCompany: {
    title: "TrustYou",
    text: "TrustYou",
    href: "https://www.trustyou.com",
    icon: "",
    bgColor: "bg-blue-0",
    ringColor: "ring-blue-0",
  },
  GitHub: {
    title: "GitHub",
    text: "GitHub",
    href: "https://github.com/aasmpro",
    icon: "fab fa-github-alt",
    bgColor: "bg-dark-0",
    ringColor: "ring-dark-0",
  },
  StackOverflow: {
    title: "StackOverflow",
    text: "StackOverflow",
    href: "https://stackoverflow.com/users/6484831/aasmpro",
    icon: "fab fa-stack-overflow",
    bgColor: "bg-orange-0",
    ringColor: "ring-orange-0",
  },
  LinkedIn: {
    title: "LinkedIn",
    text: "LinkedIn",
    href: "https://www.linkedin.com/in/aasmpro/",
    icon: "fab fa-linkedin-in",
    bgColor: "bg-blue-0",
    ringColor: "ring-blue-0",
  },
  Twitter: {
    title: "Twitter",
    text: "Twitter",
    href: "https://twitter.com/aasmpro",
    icon: "fab fa-twitter",
    bgColor: "bg-blue-0",
    ringColor: "ring-blue-0",
  },
  Telegram: {
    title: "Telegram",
    text: "Telegram",
    href: "https://telegram.me/aasmpro/",
    icon: "fas fa-paper-plane",
    bgColor: "bg-blue-0",
    ringColor: "ring-blue-0",
  },
  Instagram: {
    title: "Instagram",
    text: "Instagram",
    href: "https://www.instagram.com/aasmpro/",
    icon: "fab fa-instagram",
    bgColor: "bg-red-0",
    ringColor: "ring-red-0",
  },
  Chess: {
    title: "Chess",
    text: "Chess",
    href: "https://www.chess.com/member/aasmpro",
    icon: "fas fa-chess-king",
    bgColor: "bg-green-0",
    ringColor: "ring-green-0",
  },
  Dota2: {
    title: "Dota2",
    text: "Dota2",
    href: "https://steamcommunity.com/id/aasmpro/",
    icon: "fa-brands fa-steam-symbol",
    bgColor: "bg-red-0",
    ringColor: "ring-red-0",
  },
};
